import React from 'react';

const FolderOpenIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_8946_59252" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
        <rect width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g>
        <path
          d="M5.66659 26C5.01881 26 4.46792 25.7731 4.01392 25.3193C3.56014 24.8653 3.33325 24.3144 3.33325 23.6667V8.41033C3.33325 7.76256 3.57303 7.19889 4.05259 6.71933C4.53214 6.23978 5.09581 6 5.74359 6H13.0639L15.7306 8.66667H26.2563C26.8529 8.66667 27.3675 8.85944 27.7999 9.245C28.2324 9.63033 28.4828 10.1042 28.5513 10.6667H14.9126L12.2459 8H5.74359C5.62381 8 5.52547 8.03845 5.44859 8.11533C5.3717 8.19222 5.33325 8.29056 5.33325 8.41033V23.5897C5.33325 23.6837 5.35681 23.7606 5.40392 23.8203C5.45081 23.8803 5.5127 23.9317 5.58959 23.9743L8.69992 13.5897H30.9103L27.6819 24.3437C27.5297 24.8443 27.2447 25.2456 26.8269 25.5473C26.4089 25.8491 25.9453 26 25.4359 26H5.66659ZM7.68459 24H25.6923L28.2076 15.5897H10.1999L7.68459 24Z"
          fill="#CACED5"
        />
      </g>
    </svg>
  );
};

export default FolderOpenIcon;
